import { FileRec, GetCollectionsShowResponse } from 'mytours-read-api-typescript'
import { CollectionItem, Coordinates } from '../api/types'

export function createDistanceLabel(distanceInMeters: number, kmLabel: string): string {
	// todo need to format correctly
	// take a language param to localize units too
	// extract units to strings file (quantities)
	const kms: number = distanceInMeters / 1000
	return kms.toFixed(2) + kmLabel
}

export function createDurationLabel(distanceInMinutes: number, hrsLabel: string): string {
	// todo need to format correctly
	// take a language param to localize units too
	// extract units to strings file (quantities)
	const hours: number = distanceInMinutes / 60
	return hours.toFixed(2) + hrsLabel
}

export function isImageSVG(file?: FileRec): boolean {
	return file && file.content_type && file.content_type.includes('svg') ? true : false
}

export const calculateDistance = (firstCoords: Coordinates, secondCoords: Coordinates): number => {
    const p = Math.PI / 180
    const a = 0.5 -
		Math.cos((secondCoords.latitude - firstCoords.latitude) * p) / 2.0 +
		Math.cos(firstCoords.latitude * p) *
		Math.cos(secondCoords.latitude * p) *
    	(1 - Math.cos((secondCoords.longitude - firstCoords.longitude) * p)) / 2.0
    const sum = 12742 * Math.asin(Math.sqrt(a)) // 2 * R; R = 6371 km
    return sum
  }

export const sortItems = (items: CollectionItem[], sortBy: GetCollectionsShowResponse.SortByEnum | undefined, userLocation?: Coordinates): CollectionItem[] => {
	switch (sortBy) {
		case GetCollectionsShowResponse.SortByEnum.Alphabetical:
			return items.sort((a, b) => (a.title && b.title && a.title.toLowerCase() > b.title.toLowerCase()) ? 1 : -1)
		case GetCollectionsShowResponse.SortByEnum.Distance: {
			if (!userLocation) {
				return items
			}

			return items.sort((a, b) => {
				const aDistance = a.lat && a.lng ? calculateDistance(userLocation, { latitude: Number(a.lat), longitude: Number(a.lng) }) : Infinity
				const bDistance = b.lat && b.lng ? calculateDistance(userLocation, { latitude: Number(b.lat), longitude: Number(b.lng) }) : Infinity

				return aDistance > bDistance ? 1 : -1
			})
		}
		case GetCollectionsShowResponse.SortByEnum.ListOrder:
		default:
			return items
	}
}

export function generateCollectionVersion(): number {
	return Math.round(new Date().getTime() / 100000)
}
